// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Raleway', 'Raleway Fallback'","fontStyle":"normal"},"className":"__className_675ffd","variable":"__variable_675ffd"};